import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "collection-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }
const _hoisted_4 = { class: "tab-header" }
const _hoisted_5 = { class: "tab-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  gameList,
  gameAdd,
  gameCopy,
  gameDel,
} from "@/common/api/rest/game/game";

import type { GameType, GamePayloadType } from "@/common/types/game/game";

import { FormConsole } from "@/components";
import {
  baseAvatar,
  breadcrumbSimple,
  baseConfirm,
  baseModal,
  baseTable,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const tableData = ref<GameType[]>([]);
const payload = ref<GamePayloadType | null>(null);

const selected = ref<GameType | null>(null);

const limit = ref<number>(10);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalCopy = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);

const tableHeader = computed(() => [
  { key: "avatar", label: "" },
  { key: "name", label: t("common.labels.name") },
  { key: "status", label: t("common.labels.status") },
  { key: "type", label: t("common.labels.type") },
  { key: "is_main", label: t("collection.labels.is_main") },
  { key: "is_official", label: t("collection.labels.is_official") },
]);

const breadcrumbList = computed(() => [
  {
    key: "collection",
    label: t("common.labels.collections"),
    url: `/collection`,
  },
  {
    key: "edit",
    label: t("collection.labels.games"),
  },
]);

const status = computed(() => ({
  ACTIVE: t("common.labels.active"),
  INACTIVE: t("common.labels.inactive"),
}));

function fetchData() {
  gameList({
    page: page.value,
    limit: limit.value,
    search: search.value,
    sort: "DESC",
  })
    .then((response) => {
      const { success, data, message } = response;
      if (success) {
        tableData.value = data.list;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changePage(value: number) {
  page.value = value;
  fetchData();
}

function searchItem(value: string) {
  search.value = value;

  fetchData();
}

function addItem() {
  showModalAdd.value = true;
}

function addItemCancel() {
  showModalAdd.value = false;
  payload.value = null;
}

function addItemConfirm() {
  if (!payload.value) return;

  store.commit("SET_LOADING", true);

  gameAdd(payload.value)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        editItem(data);
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function editItem(data: GameType) {
  // router.push(`/collection/game/${data.game_id}/infos`);
  window.open(`/collection/game/${data.game_id}/infos`, "_blank");
}

function copyItem(data: GameType) {
  selected.value = data;
  showModalCopy.value = true;
}

function copyItemCancel() {
  showModalCopy.value = false;
  selected.value = null;
}

function copyItemConfirm() {
  if (!selected.value) return;

  store.commit("SET_LOADING", true);

  gameCopy(selected.value.game_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        editItem(data);
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function removeItem(data: GameType) {
  selected.value = data;
  showModalDel.value = true;
}

function removeItemCancel() {
  showModalDel.value = false;
  selected.value = null;
}

function removeItemConfirm() {
  if (!selected.value) return;

  gameDel(selected.value.game_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        removeItemCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          active: "edit",
          "url-home": "/home"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(svgIcon), {
            icon: "no-image",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("collection.labels.games")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(baseTable), {
            header: tableHeader.value,
            data: tableData.value,
            limit: limit.value,
            page: page.value,
            pages: pages.value,
            total: total.value,
            searched: searched.value,
            options: true,
            copy: true,
            edit: true,
            del: true,
            "onChange:page": _cache[0] || (_cache[0] = ($event: any) => (changePage($event))),
            onSearching: _cache[1] || (_cache[1] = ($event: any) => (searchItem($event))),
            "onBtn:add": _cache[2] || (_cache[2] = ($event: any) => (addItem())),
            "onBtn:copy": _cache[3] || (_cache[3] = ($event: any) => (copyItem($event))),
            "onBtn:edit": _cache[4] || (_cache[4] = ($event: any) => (editItem($event))),
            "onBtn:del": _cache[5] || (_cache[5] = ($event: any) => (removeItem($event)))
          }, {
            avatar: _withCtx(({ data }) => [
              _createVNode(_unref(baseAvatar), {
                position: "center",
                "is-edit": false,
                "show-image": true,
                url: data?.avatar?.large,
                "aspect-ratio": 1.333,
                size: "3rem",
                "border-radius": "0.25rem"
              }, null, 8, ["url"])
            ]),
            status: _withCtx(({ data }) => [
              _createTextVNode(_toDisplayString(status.value[data.status]?.toUpperCase()), 1)
            ]),
            is_main: _withCtx(({ data }) => [
              (data.is_main)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.yes")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.not")), 1)
                  ], 64))
            ]),
            is_official: _withCtx(({ data }) => [
              (data.is_official)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.yes")), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.not")), 1)
                  ], 64))
            ]),
            _: 1
          }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"])
        ])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('collection.modals.titles.add_collection').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (addItemCancel())),
      onConfirm: _cache[9] || (_cache[9] = ($event: any) => (addItemConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormConsole), {
          "onUpdate:data": _cache[6] || (_cache[6] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[7] || (_cache[7] = ($event: any) => (payloadValid.value = $event))
        })
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalCopy.value,
      title: _unref(t)('collection.modals.titles.copy_collection').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.copy_collection', {
        name: selected.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (copyItemCancel())),
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (copyItemConfirm()))
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('collection.modals.titles.del_collection').toUpperCase(),
      message: 
      _unref(t)('collection.modals.messages.del_collection', {
        name: selected.value?.name?.toUpperCase(),
      })
    ,
      onCancel: _cache[12] || (_cache[12] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[13] || (_cache[13] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})